import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tc-sidebar-brand',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sidebar-brand.component.html',
  styleUrl: './sidebar-brand.component.css',
})
export class SidebarBrandComponent {
  logoSrc = input<string>('');
  label = input<string>('');
}
